import isPathAttributes from './isPathAttributes';
import type { Path } from './types';

export default (obj: unknown): obj is Path => isPathAttributes(obj) || typeof obj === 'string';
